const PointSetting = {
  path: "",
  name: "",
  redirect: "/point-setting",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/point-setting",
      redirect: "/point-setting",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Point Setting",
      meta: {
        requiresAuth: true,
        activeUrl: "/point-setting",
        parent: "point_setting",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/pointSetting"),
          meta: {
            requiresAuth: true,
            activeUrl: "/point-setting",
            parent: "point_setting",

            lv: 2,
          },
        },
        // {
        //   path: "detail/:id",
        //   name: "Point Setting Detail",
        //   component: () => import("@/views/pages/memberTier/detail/Detail"),
        //   meta: {
        //     requiresAuth: true,
        //     isChildren: true,
        //     activeUrl: "/point-setting",
        //     parent: "membertier",

        //     lv: 3,
        //   },
        // },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default PointSetting;
